import React from 'react';
import { motion } from 'framer-motion';

const topPath = ['0%', '100%', '80%', '15%', '0%'];
const bottomPath = ['100%', '50%', '0%', '50%', '100%'];
const mirrorPath = path => path.map(value => `${100 - parseFloat(value)}%`);
const liquidShapes = [
  '48% 52% 58% 42% / 52% 45% 55% 48%',
  '60% 40% 48% 52% / 44% 56% 44% 56%',
  '43% 57% 40% 60% / 58% 43% 57% 42%',
  '56% 44% 60% 40% / 42% 58% 42% 58%',
  '48% 52% 58% 42% / 52% 45% 55% 48%',
];

/** Uses the same animation engine as profile-ring, per the requested visible motion. */
export const GlassShineCard = ({ children, className = '', mirrored = false }) => (
  <div className="glass-shine-scene">
    <motion.span
      className="glass-shine-orb glass-shine-orb-top"
      aria-hidden="true"
      style={{ x: '-50%' }}
      animate={{
        left: mirrored ? mirrorPath(topPath) : topPath,
        y: ['0%', '15%', '90%', '45%', '0%'],
        scaleX: [1.05, 1.15, .9, .98, 1.05],
        scaleY: [.98, 1.04, .92, 1.06, .98],
        borderRadius: liquidShapes,
      }}
      transition={{ duration: 44, repeat: Infinity, ease: 'easeInOut' }}
    />
    <motion.span
      className="glass-shine-orb glass-shine-orb-bottom"
      aria-hidden="true"
      style={{ x: '-50%' }}
      animate={{
        left: mirrored ? mirrorPath(bottomPath) : bottomPath,
        y: ['0%', '-15%', '5%', '-10%', '0%'],
        scaleX: [1.05, .96, 1.12, .98, 1.05],
        scaleY: [.96, 1.06, .98, 1.04, .96],
        borderRadius: liquidShapes,
      }}
      transition={{ duration: 40, repeat: Infinity, ease: 'easeInOut' }}
    />
    <article className={`glass-shine-card ${className}`.trim()}>
      <div className="glass-shine-card-content">{children}</div>
    </article>
  </div>
);

export const SampleCard = () => (
  <GlassShineCard>
    <h3>SAMPLE TEXT</h3>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer id dictum augue, id viverra.</p>
  </GlassShineCard>
);
